/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from 'components';
import { Ready, InProgress, DeleteIcon, Awaiting } from 'assets/icons';
import * as S from './AppStatus.styled';
import { routes } from 'config';
import { redirectToOldPlatformUrl } from 'utils';
import { appStatuses } from 'constants';
import { FixUrlComponent } from './FixUrlComponent';

const compaignsCounter = (value) => {
  return value === 1 ? ` Campaign` : ' Campaigns';
};

function choosePath(status, pba_id) {
  switch (status) {
    case appStatuses.ready_to_promote:
      return `${
        routes.list.find((route) => route.id === 'campaign/newCampaign_empty').url
      }?app=${pba_id}`;
    case appStatuses.promoting:
      return routes.list.find((route) => route.id === 'campaign').url;
    case appStatuses.awaiting:
      console.log('here');
      window.open('https://developers.appnext.com/', '_blank');
      return;
    default:
      return '/';
  }
}

const AppStatus = ({ status, campaign_count, pba_number, pba_id, isRedirect$ }) => {
  const navigate = useNavigate();
  let newUrl = '';

  switch (status) {
    case appStatuses.ready_to_promote:
      return (
        <S.StatusWrapp>
          <Ready />
          <span>
            Ready to
            <S.MyLink to={choosePath(status, pba_id)}>Promote</S.MyLink>
          </span>
        </S.StatusWrapp>
      );
    case appStatuses.promoting:
      return (
        <S.StatusWrapp>
          <InProgress />
          <span>
            Promoting in
            <S.Box
              onClick={(e) => {
                // if (window.REACT_APP_ENV === 'production') {
                //   isRedirect$.value = true;
                //   newUrl = redirectToOldPlatformUrl(`/Discovery/Manage.aspx`);
                //   window.location.href = newUrl;
                //   return;
                // }
                if (window.REACT_APP_ENV === 'qa' || window.REACT_APP_ENV === 'production') {
                  navigate(choosePath(status));
                  console.log({ pba_number });
                  localStorage.removeItem('tableState');
                  localStorage.setItem('filteredItems', JSON.stringify(pba_number));
                  return;
                }
              }}
            >
              {status?.value}&nbsp;
              {campaign_count}
              {compaignsCounter(campaign_count)}
            </S.Box>
          </span>
        </S.StatusWrapp>
      );
    case appStatuses.archived:
      return (
        <S.StatusWrapp>
          <DeleteIcon />
          <span>Archived</span>
        </S.StatusWrapp>
      );
    case appStatuses.awaiting:
      return (
        <S.StatusWrapp>
          <Awaiting />
          <S.AwaitingStatusWrap>Awaiting</S.AwaitingStatusWrap>
          <span>
            for
            <S.MyA href='https://developers.appnext.com/' target='_blank' rel='noopener noreferrer'>
              SDK integration
            </S.MyA>
          </span>
        </S.StatusWrapp>
      );
    case appStatuses.monetising:
      return (
        <S.StatusWrapp>
          <InProgress />
          <span>Monetising</span>
        </S.StatusWrapp>
      );
    case appStatuses.error:
      return <FixUrlComponent pba_number={pba_number} pba_id={pba_id} />;
    default:
      break;
  }
};

AppStatus.propTypes = {
  status: PropTypes.string.isRequired,
};

export default AppStatus;
